import { SelectOption } from '@payaca/ambrosia';

/**
 * Ensures the currently selected option is present in a Combobox/Select's
 * options list. Paginated option sources may omit the selected value; without
 * this, the Combobox cannot render a label for it and the selection appears
 * cleared.
 */
export function mergeSelectedIntoOptions<
  TValue extends number | string | null,
  TMeta = object,
>(
  options: SelectOption<TValue, TMeta>[],
  selected: SelectOption<TValue, TMeta> | null | undefined
): SelectOption<TValue, TMeta>[] {
  if (!selected) return options;
  if (options.some((o) => o.value === selected.value)) return options;
  return [selected, ...options];
}
